import React, { useEffect, useState } from "react";
import {
  Box,
  Grid,
  Button,
  Dialog,
  Grid2,
  Autocomplete,
  TextField,
} from "@mui/material";
import AddOutlinedIcon from "@mui/icons-material/AddOutlined";
import AddPublicHoliday from "../../components/PublicHoliday/AddPublicHoliday";
import { useNavigate, useLocation } from "react-router-dom";
import {
  deletePublicHoliday,
  getPublicHoliday,
} from "../../services/publicHoliday.service";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import moment from "moment";
import MasterCommonTable from "../../sharedComponents/MaterCommonTable/MasterCommonTable";
import { ToastError } from "../../utils/Toaster/Toaster";
import CalendarTodayRoundedIcon from "@mui/icons-material/CalendarTodayRounded";
import { jwtDecode } from "jwt-decode";
import { encryptData } from "../../utils/cryptoUtils";
import { useAuth } from "../../context/AuthProvider";
import { Search } from "@mui/icons-material";
import AddParentTask from "../../components/ParentTask/AddParentTask";
import PermissionGate from "../../components/Permission/PermissionGate";
import { usePermissions } from "../../context/PermissionProvider";
import {
  deleteParentTask,
  getParentTask,
  changeParentTask,
} from "../../services/parentTask";
import { getProject } from "../../services/project.service";
import { isAdminRole } from "../../utils/roles";

const ParentTask = () => {
  const [openDrawer, setOpenDrawer] = useState(false);
  const [data, setData] = useState([]);
  const { accessToken } = useAuth();
  const { canAdd, canEdit, canDelete } = usePermissions();
  const [selectedData, setSelectedData] = useState({});
  const [tableTotalCount, setTableCount] = useState(0);
  const [who, setIsWho] = useState(false);
  const [formType, setFormType] = useState("add");
  const [projects, setProjects] = useState([]);
  const [selectedProject, setSelectedProject] = useState(null);
  const [queryParam, setQueryParam] = useState({
    projectId: "",
    search: "",
    page: 1,
    limit: 10,
    sort: "",
  });
  // console.log("Query Params:", queryParam);
  const currentYear = dayjs().year();
  const minYear = currentYear - 9;
  const maxYear = currentYear + 10;

  const navigate = useNavigate();
  const location = useLocation();
  const fromDashboard = location.state?.fromDashboard;

  const getParentTaskData = async () => {
    try {
      //   const encryptedYear = encryptData(queryParam.year);
      //   const encryptedType = encryptData(queryParam.type);
      const res = await getParentTask(queryParam);
      const modifiedData = res.data.data.map((e) => {
        return {
          ...e,
          projectName: e?.project_info.name,
          projectTypeName: e?.projectType?.name || "-",
        };
      });
      setData(modifiedData);
      setTableCount(res?.data?.totalCount || 0);
    } catch (error) {
      console.log(error);
    }
  };

  const fetchProjects = async () => {
    try {
      const response = await getProject({ isEnabled: true });
      setProjects(response.data.data);
    } catch (error) {
      console.error("Error fetching projects:", error);
    }
  };

  //const who = JSON.parse(localStorage.getItem("isOverAllAdmin"));

  useEffect(() => {
    // const token = localStorage.getItem("token");
    if (accessToken) {
      try {
        const decodedToken = jwtDecode(accessToken);
        setIsWho(isAdminRole(decodedToken.role));
      } catch (error) {
        console.error("Error decoding token:", error);
      }
    }
  }, []);
  console.log("Current Role (who):", who);

  useEffect(() => {
    getParentTaskData();
  }, [queryParam.projectId, queryParam.page, queryParam.limit, queryParam.sort]);

  useEffect(() => {
    fetchProjects();
  }, []);

  const handleAdd = () => {
    setFormType("add");
    setOpenDrawer(true);
    setSelectedData({});
  };

  const handleView = (e) => {
    setFormType("view");
    setOpenDrawer(true);
    setSelectedData(e);
  };

  const handleEdit = (e) => {
    //const res = await changeParentTask(e._id);
    //e.isView = false;
    //e.isProjectDisabled = res.data.used;
    setFormType("edit");
    setSelectedData(e);
    setOpenDrawer(true);
    // } catch (err) {
    //   console.error("Error checking parentTask usage", err);
    //   e.isView = false;
    //   e.isProjectDisabled = false;
    //   setSelectedData({ ...e });
    //   setOpenDrawer(true);
    // }
  };

  const handleDelete = async (e) => {
    try {
      const res = await deleteParentTask(e._id);
      getParentTaskData();
      ToastError(res.message);
    } catch (error) {
      console.log(error);
    }
  };

  const handleTableEvent = (e) => {
    setQueryParam({
      ...queryParam,
      page: e.page,
      limit: e.limit,
      sort: e.sort,
    });
  };

  const columns = [
    { id: "code", label: "Code" },
    { id: "projectName", label: "Project" },
    { id: "projectTypeName", label: "Project Type" },
    { id: "title", label: "Title" },
    { id: "description", label: "Description" },
  ];

  const tableConfig = {
    isMore: true,
    isAction: who === true ? true : true,
    isAdmin: true,
    isView: true,
    isEdit: canEdit("parentTask"),
    isDelete: canDelete("parentTask"),
  };

  return (
    <div className="mainPageRenderingContainer">
      <Box sx={{ height: "fit-content" }}>
        <Grid container spacing={{ xs: 1, sm: 2 }} sx={{ justifyContent: "space-between" }}>
          <Grid item xs={12} sm={3}>
            <Autocomplete
              options={projects}
              getOptionLabel={(option) => option.name}
              value={selectedProject}
              onChange={(e, v) => {
                setSelectedProject(v);
                setQueryParam({
                  ...queryParam,
                  projectId: v ? v._id : "",
                });
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  placeholder="Select Project"
                  className="AutoComplete_InputBox"
                />
              )}
            />
          </Grid>
          <Grid item xs={12} sm={2} sx={{ display: { xs: "none", sm: "block" } }} />
          {who === false ? (
            <Grid item xs={12} sm={2.5} sx={{ display: { xs: "none", sm: "block" } }} />
          ) : (
            <Grid item xs={12} sm={0.5} sx={{ display: { xs: "none", sm: "block" } }} />
          )}
          {/* <Grid item xs={12} sm={2.5}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DemoContainer components={["DatePicker", "DatePicker"]}>
                <DatePicker
                  views={["year"]}
                  openTo="month"
                  value={dayjs(queryParam.year)}
                  className="datePicker w-100"
                  minDate={dayjs().year(minYear)} // Setting the minimum allowed year
                  maxDate={dayjs().year(maxYear)}
                  onChange={(e) => {
                    setQueryParam({
                      ...queryParam,
                      year: moment(e?.$d).format("YYYY"),
                    });
                  }}
                  slots={{
                    openPickerIcon: CalendarTodayRoundedIcon,
                  }}
                />
              </DemoContainer>
            </LocalizationProvider>
          </Grid> */}
          {/* <Grid item xs={12} sm={1.5}>
            <Autocomplete
              options={HolidayType}
              disableClearable={true}
              value={
                HolidayType.find((option) => option.name === queryParam.type) ||
                null
              }
              className="w-100"
              onChange={(e, v) => {
                setQueryParam({
                  ...queryParam,
                  type: v ? v.name : queryParam.type,
                });
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  placeholder="Select Status"
                  className="AutoComplete_InputBox"
                  focused={false}
                />
              )}
            />
          </Grid> */}
          {/* {who === false ? (
            <Grid item xs={12} sm={2.5} />
          ) : ( */}
          <Grid item xs={12} sm={3}>
            <PermissionGate module="parentTask" action="add">
              <Button
                startIcon={<AddOutlinedIcon />}
                onClick={() => handleAdd()}
                className="Add-Button w-100"
              >
                Add Parent Task
              </Button>
            </PermissionGate>
          </Grid>
          {/* )} */}

          {/* <Grid item xs={12} sm={3}>
          <Button
            startIcon={<AddOutlinedIcon />}
            onClick={() => handleAddEmployee()}
            className="Add-Button w-100"
          >
            Add Employee
          </Button>
        </Grid> */}
        </Grid>
      </Box>
      <MasterCommonTable
        tableConfig={tableConfig}
        data={data}
        columns={columns}
        handleEdit={handleEdit}
        handleView={handleView}
        handleDelete={handleDelete}
        isServerSide={true}
        tableTotalCount={tableTotalCount}
        tableOutputEvent={handleTableEvent}
      />
      <Dialog
        open={openDrawer}
        PaperProps={{
          style: {
            width: "100%",
            height: "fit-content",
          },
        }}
        fullWidth
        maxWidth="sm"
      >
        {openDrawer ? (
          <AddParentTask
            selectedData={selectedData}
            setOpenDrawer={setOpenDrawer}
            //selectedData.isView ? "view" : selectedData._id ? "edit" : "ad"
            formType={formType}
            GetData={getParentTaskData}
          />
        ) : null}
      </Dialog>
    </div>
  );
};

export default ParentTask;
